import { getNowLocalDateTime } from "./nowLocalDateTime";

const FIRST_VIEWING_HOUR = 9;
const LAST_VIEWING_HOUR = 18;
const VIEWING_TIME_STEP_IN_MINUTES = 30;

const pad = (n: number) => String(n).padStart(2, "0");

/**
 * Every time a viewing can be requested at, as HH:mm: on the hour and half
 * hour during office hours. A fixed list rather than a step on a native time
 * control, because iOS ignores `step` and would still offer every minute.
 */
export const VIEWING_TIMES: readonly string[] = Array.from(
    {
        length:
            ((LAST_VIEWING_HOUR - FIRST_VIEWING_HOUR) * 60) /
                VIEWING_TIME_STEP_IN_MINUTES +
            1,
    },
    (_, i) => {
        const minutes =
            FIRST_VIEWING_HOUR * 60 + i * VIEWING_TIME_STEP_IN_MINUTES;
        return `${pad(Math.floor(minutes / 60))}:${pad(minutes % 60)}`;
    }
);

/**
 * The viewing times still open on `date` (YYYY-MM-DD): all of them on a
 * future day, only those after the current time today, none on a past day.
 *
 * @param now - Overridable for tests.
 */
export const getViewingTimesOn = (date: string, now: Date = new Date()) => {
    const [today, currentTime] = getNowLocalDateTime(now).split("T");
    if (!date || date > today) return VIEWING_TIMES;
    if (date < today) return [];
    return VIEWING_TIMES.filter((time) => time > currentTime);
};

/**
 * The first day a viewing can be requested on: today while it still has an
 * open time, otherwise tomorrow.
 *
 * @param now - Overridable for tests.
 */
export const getFirstViewingDate = (now: Date = new Date()) => {
    const [today] = getNowLocalDateTime(now).split("T");
    if (getViewingTimesOn(today, now).length > 0) return today;
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);
    return getNowLocalDateTime(tomorrow).split("T")[0];
};
